import React, { useEffect, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PortalApi from "api/PortalApi";
import { HomePageCarousel } from "models/Response/Portal";
import { CustomButton, CustomModal } from "albinasoft-ui-package";

interface ArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

function SampleNextArrow({ className, style, onClick }: ArrowProps) {
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "rgba(0, 0, 0, 0)",
        borderRadius: "50%",
        right: "20px",
        zIndex: 2,
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow({ className, style, onClick }: ArrowProps) {
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "rgba(0, 0, 0, 0)",
        borderRadius: "50%",
        left: "20px",
        zIndex: 2,
      }}
      onClick={onClick}
    />
  );
}

const sliderSettings = {
  dots: false,
  infinite: true,
  fade: false,
  speed: 2000,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};

const SlideContainer = styled.div`
  position: relative;
  height: 70vh;
`;

const SlideImage = styled.img`
  ${tw`w-full h-full object-cover object-center`}
`;

const SlideDarkOverlay = styled.div`
  ${tw`absolute inset-0 bg-black opacity-50 pointer-events-none`}
`;

const SlideContent = styled.div`
  ${tw`absolute inset-0 flex flex-col justify-center items-center text-white`}
  z-index: 3;
  padding: 1rem;
  text-align: center;
`;

const AnnouncementText = styled.h2`
  ${tw`
    2xsm:font-hairline
    xsm:font-thin
    sm:font-light
    md:font-medium
    lg:font-medium
    xl:font-semibold
    2xl:font-semibold
    3xl:font-semibold
  `}
  font-size: clamp(0.75rem, 2vw + 0.5rem, 2.25rem);
`;

const AnnouncementButton = styled.button`
  ${tw`mt-4 px-6 py-2 bg-primary-600 text-white font-semibold rounded hover:bg-primary-700 transition duration-300`}
`;

const Carousel: React.FC = () => {
  const [carouselList, setCarouselList] = useState<HomePageCarousel[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedCarousel, setSelectedCarousel] = useState<HomePageCarousel | null>(null);

  const handleButtonClick = (item: HomePageCarousel) => {
    if (item.actionType === 1 && item.redirectLink) {
      window.open(item.redirectLink, "_blank", "noopener,noreferrer");
    } else if (item.actionType === 2) {
      setSelectedCarousel(item);
      setShowModal(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await PortalApi.getHomePageData();
      if (response && response.carouselList) {
        setCarouselList(response.carouselList);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <Slider {...sliderSettings}>
        {carouselList.map((item, index) => (
          <SlideContainer key={index}>
            <SlideImage src={item.bannerImageUrl} alt={`slide-${index}`} />
            <SlideDarkOverlay />
            <SlideContent>
              <AnnouncementText>{item.introText}</AnnouncementText>
              {item.actionType !== 3 && (
                <AnnouncementButton onClick={() => handleButtonClick(item)}>
                  {item.actionType === 2 ? "Detaylar" : "Detaylar"}
                </AnnouncementButton>
              )}
            </SlideContent>
          </SlideContainer>
        ))}
      </Slider>
      <CustomModal
        title={selectedCarousel?.introText}
        show={showModal}
        size="lg"
        onHide={() => setShowModal(false)}
        footer={<CustomButton onClick={() => setShowModal(false)} label="Kapat" />}
      >
        {selectedCarousel?.popupContent
          ? selectedCarousel.popupContent.split("\n").map((line, idx) => (
            <p key={idx} style={{ marginBottom: "0.5rem" }}>
              {line}
            </p>
          ))
          : "İçerik Yazısı Bulunamadı"}
      </CustomModal>
    </div>
  );
};

export default Carousel;
